import React, { useState } from "react";
import Header from "../components/Header";
import Footer from "../components/Footer";
import "./vp7200.css";

function UN20() {
  const [mainImage, setMainImage] = useState("/images/un20/7-1.png");
  const [activeTab, setActiveTab] = useState("features");

  const thumbnails = [
    "/images/un20/7-1.png",
    "/images/un20/7-2.png",
    "/images/un20/7-3.png",
    "/images/un20/7-4.png",
    "/images/un20/7-5.png"
  ];
  return (
    <>
      <Header />
      <section className="vp7200-container">

        {/* LEFT SIDE */}
        <div className="vp7200-left">
          <div className="main-image">
            <img src={mainImage} alt="VP7200" />
          </div>

          {/* <div className="thumbnails">
            {thumbnails.map((img, index) => (
              <img
                key={index}
                src={img}
                alt=""
                onClick={() => setMainImage(img)}
              />
            ))}
          </div> */}
          <div className="thumbnails">

            {/* TOP ROW (2 IMAGES) */}
            <div className="thumb-row top-row">
              {thumbnails.slice(0, 3).map((img, index) => (
                <img
                  key={index}
                  src={img}
                  alt=""
                  onClick={() => setMainImage(img)}
                />
              ))}
            </div>

            {/* BOTTOM ROW (3 IMAGES) */}
            <div className="thumb-row bottom-row">
              {thumbnails.slice(3, 5).map((img, index) => (
                <img
                  key={index}
                  src={img}
                  alt=""
                  onClick={() => setMainImage(img)}
                />
              ))}
            </div>

          </div>
        </div>

        {/* RIGHT SIDE */}
        <div className="vp7200-right">

          {/* TOP CONTENT */}
          <div className="content-top">
            <h1>UN20</h1>
            <h3></h3>

            <p>
              The UN20 is a powerful all-in-one unattended payment solution, designed to handle high-demand environments with ease-combining rugged durability, advanced payment options, and seamless integration for vending, kiosks, and self-service applications.
            </p>
          </div>

          {/* TABS */}
          <div className="tabs">
            <button
              className={activeTab === "features" ? "active" : ""}
              onClick={() => setActiveTab("features")}
            >
              KEY FEATURES
            </button>

            <button
              className={activeTab === "specs" ? "active" : ""}
              onClick={() => setActiveTab("specs")}
            >
              SPECIFICATIONS
            </button>
          </div>

          {/* TAB CONTENT */}
          <div className="tab-content">
            {activeTab === "features" && (
              <ul>
                <li>Android 10 smart payment platform</li>
                <li>4" capacitive multi-touch display for intuitive user interaction</li>
                <li>Supports chip and contactless payments for fast and secure transactions</li>
                <li>Software PIN pad with fixed PIN support</li>
                <li>Compact, lightweight design suitable for integration into kiosks and machines</li>
                <li>Front camera for scanning and customer interaction</li>
                <li>4G, Wi-Fi and Bluetooth connectivity for reliable communication</li>
                <li>GPS, GLONASS and BeiDou positioning support</li>
                <li>Rechargeable battery for portable deployments</li>
                <li>Optional integrated payment module base and charging base</li>
                <li>Supports unattended deployment within automated payment environments</li>
              </ul>
            )}

            {activeTab === "specs" && (
              <ul>
                <li>Connectivity: USB-C, Ethernet, LTE</li>
                <li>Operating Temp: -30°C to 70°C</li>
                <li>Security: PCI PTS 6.x</li>
                <li>Ingress Protection: IP65</li>
                <li>Dimensions: Compact form factor</li>
              </ul>
            )}
          </div>
        </div>
      </section>
      <section className="vp7200-benefits">

        <div className="vp7200-benefits-container">

          {/* LEFT CONTENT */}
          <div className="benefits-left">
            <h2>Why Chose UN20</h2>

            <ul>
              <li>Designed for Unattended Environments</li>
              <li>Ideal for vending, kiosks and self-service applications</li>
              <li>Flexible Payment Acceptance</li>
              <li>Supports magstripe, chip, contactless and software PIN entry</li>
              <li>Strong Integration Capability</li>
              <li>Multiple interfaces including USB, LAN, RS232, MDB and HDMI</li>
              <li>Built-In Scanning Functionality</li>
              <li>Front and bottom cameras for barcode and QR code scanning</li>
              <li>Rugged & Reliable Design</li>
              <li>IP65 and IK09 rated for indoor and outdoor deployment</li>
            </ul>

            {/* PAYMENT METHODS */}
            <h3 className="payment-title">Multiple Payment Methods</h3>

            <div className="payment-logos">
              <img src="/images/7200/gpay.png" alt="GPay" />
              <img src="/images/7200/mc.png" alt="Mastercard" />
              <img src="/images/7200/amex.png" alt="Amex" />
              <img src="/images/7200/visa.png" alt="Visa" />
              <img src="/images/7200/apple.png" alt="Apple Pay" />
              <img src="/images/7200/samsung.png" alt="Samsung Pay" />
              <img src="/images/7200/alipay.png" alt="Alipay" />
            </div>
          </div>

          {/* RIGHT IMAGE */}
          <div className="benefits-right">
            <img
              src="/images/un20/7-6.png"
              alt="Kiosk"
            />
          </div>
        </div>
      </section>
      <section className="vp7200-features">
        <div className="vp7200-features-container">
          <div className="feature-item">
            <img src="/images/7200/flex-connect.png" alt="Connectivity" />
            <h4>Flexible Connectivity</h4>
            <p>Integrate seamlessly into your existing infrastructure.</p>
          </div>

          <div className="feature-item">
            <img src="/images/7200/secure.png" alt="Security" />
            <h4>Secure & Compliant</h4>
            <p>Protect your business and customers with advanced security.</p>
          </div>

          <div className="feature-item">
            <img src="/images/7200/rugged.png" alt="Rugged" />
            <h4>Rugged & Reliable</h4>
            <p>Built to withstand tough environments and 24/7 use.</p>
          </div>

          <div className="feature-item">
            <img src="/images/7200/cust.png" alt="Customer" />
            <h4>Customer Engagement</h4>
            <p>Enhance the payment experience and drive loyalty.</p>
          </div>
        </div>
      </section>
      <section className="vp7200-specs">

        <div className="vp7200-specs-container">

          <h2 className="specs-title">Technical Specifications</h2>

          {/* ELECTRICAL */}
          <div className="spec-group">
            <div className="spec-label">ELECTRICAL</div>

            <div className="spec-content electrical">
              <div className="spec-row">
                <span>OS</span>
                <p>ANDROID 10</p>
              </div>

              <div className="spec-row">
                <span>PROCESSOR</span>
                <p>QUAD-CORE CORTEX-A53, 2.0GHZ</p>
              </div>

              <div className="spec-row">
                <span>COMMUNICATION</span>
                <p>4G/3G/2G WI-FI, 802.11A/B/G/N, 2.4GHZ & 5GHZ BT4.X</p>
              </div>

              <div className="spec-row">
                <span>BATTERY</span>
                <p>DC: 12~48V(DIGITAL I/O, MDB SLAVE, MASTER & EXECUTIVE), RS232<br/>AC: 19~30V(MDB MASTER & EXECUTIVE)</p>
              </div>

              <div className="spec-row">
                <span>CERTIFICATIONS</span>
                <p>PCL6.X, EMV L1&L2, EMV CL1, QPBOC L1, QUICKPASS, PAYPASS,<br/>PAYWAVE, TQM, JCB, DISCOVER, AMEX, IP65, IK09, ATEX, CE, ROHS, PTCRB</p>
              </div>

              <div className="spec-row">
                <span>POSITIONING</span>
                <p>GPS, GLONASS OR BEIDOU</p>
              </div>

              <div className="spec-row">
                <span>PIN PAD</span>
                <p>SOFTWARE PIN PAD / FIXED PIN SUPPORTED</p>
              </div>

              <div className="spec-row">
                <span>POWER</span>
                <p>DC: 12~48V(DIGITAL I/O, MDB SLAVE, MASTER & EXECUTIVE), RS232<br/>AC: 19~30V(MDB MASTER & EXECUTIVE)</p>
              </div>

              <div className="spec-row">
                <span>KEYS</span>
                <p>1 RESET KEY, 2 VOLUME KEYS</p>
              </div>
            </div>
          </div>

          {/* ENVIRONMENTAL */}
          <div className="spec-group">
            <div className="spec-label">ENVIRONMENTAL</div>

            <div className="spec-content environmental">
              <div className="spec-row">
                <span>OPERATING TEMPERATURE</span>
                <p>-20°C TO 70°C</p>
              </div>

              <div className="spec-row">
                <span>STORAGE TEMPERATURE</span>
                <p>-30°C TO 80°C</p>
              </div>

              <div className="spec-row">
                <span>RELATIVE HUMIDITY</span>
                <p>10% TO 95%</p>
              </div>

              <div className="spec-row">
                <span>WATERPROOF AND DUSTPROOF</span>
                <p>MATCH IP65 STANDARD</p>
              </div>

            </div>
          </div>

          {/* MECHANICAL */}
          <div className="spec-group">
            <div className="spec-label">MECHANICAL</div>

            <div className="spec-content mechanical">
              <div className="spec-row">
                <span>DIMENSIONS</span>
                <p>146 X 101 X 57MM (620G)</p>
              </div>

              <div className="spec-row">
                <span>MEMORY</span>
                <p>2GB RAM + 8GB ROM<br/>(MICRO SD CARD SUPPORTED, UP TO 128GB)</p>
              </div>

              <div className="spec-row">
                <span>DISPLAY</span>
                <p>4" (480 X 480) COLOR SCREEN, CAPACITIVE TOUCHSCREEN, MULTI-TOUCH</p>
              </div>

              <div className="spec-row">
                <span>CAMERAS</span>
                <p>FRONT: 2MP, FF / BOTTOM: 2MP, FF WITH FLASHLIGHT</p>
              </div>

              <div className="spec-row">
                <span>CARD SLOTS</span>
                <p>1 X SD + 4 X SAM + 2 X SIM<br/>1 X SD + 4 X SAM + 1 X ESIM<br/>1 X SIM (OPTIONAL)</p>
              </div>
            </div>
          </div>
        </div>
      </section>
      <Footer />
    </>
  );
}

export default UN20;